import React from "react";
import NavHeader from "components/torneos/NavHeader";
import NavRow from "components/torneos/NavRow";

// Pantalla de selección: lista de labels (uno debajo del otro) para elegir
// año / torneo / rueda / zona / fecha en la sección de resultados.
export default function PickScreen({ title, subtitle, options = [], emptyText, onSelect, onBack }) {
  return (
    <div className="screen-slide">
      <NavHeader title={title} subtitle={subtitle} onBack={onBack} />
      {options.length === 0 ? (
        <p className="text-muted text-center py-4 my-0" style={{ fontSize: "0.875rem" }}>
          {emptyText || "No hay opciones disponibles."}
        </p>
      ) : (
        options.map((opt) => (
          <NavRow
            key={opt.key}
            title={opt.label}
            accent={opt.accent}
            badges={opt.badges || []}
            onClick={() => onSelect(opt.key)}
          />
        ))
      )}
    </div>
  );
}
